<div class="modal-content">
  <div class="modal-header">
    <span class="text"
      ><b>{{ label! | translate }}</b></span
    >
    <i
      ><img
        class="icon"
        src="../../../assets/icons/Close--Streamline-Ultimate.svg"
        (click)="closeModal()"
    /></i>
  </div>
  <hr />
  <div class="modal-body">
    <ng-template class="form" #form></ng-template>
  </div>
</div>
